'use client';
import { useEffect, useState } from 'react';

const CSE_SCRIPT_ID = 'google-cse-loader';

function readQuery() {
	try {
		return (new URLSearchParams(window.location.search).get('q') || '').trim();
	} catch {
		return '';
	}
}

export default function SearchResults({ cseId, siteHost }) {
	// `null` até hidratar: a página vem do cache sem saber o termo.
	const [query, setQuery] = useState(null);

	useEffect(() => {
		setQuery(readQuery());
	}, []);

	useEffect(() => {
		if (!query || !cseId || document.getElementById(CSE_SCRIPT_ID)) return;
		const s = document.createElement('script');
		s.id = CSE_SCRIPT_ID;
		s.async = true;
		s.src = `https://cse.google.com/cse.js?cx=${encodeURIComponent(cseId)}`;
		document.head.appendChild(s);
	}, [query, cseId]);

	const googleFallback =
		query && siteHost
			? `https://www.google.com/search?q=${encodeURIComponent(`site:${siteHost} ${query}`)}`
			: '';

	return (
		<section id="SearchPage">
			<h1 className="search-title">
				{query ? (
					<>
						Resultados para <span>“{query}”</span>
					</>
				) : (
					'Buscar no TV Foco'
				)}
			</h1>

			<form className="search-form" action="/busca/" method="get" role="search">
				<input
					type="search"
					name="q"
					key={query ?? 'pending'}
					defaultValue={query || ''}
					placeholder="Digite o que procura"
					aria-label="Buscar notícias"
					autoComplete="off"
					autoFocus={query === ''}
					required
				/>
				<button type="submit">Buscar</button>
			</form>

			{query && cseId ? (
				<div className="search-results">
					{/* O cse.js lê `q` da URL e preenche este elemento. */}
					<div
						className="gcse-searchresults-only"
						data-queryParameterName="q"
						data-linkTarget="_self"
						data-enableHistory="false"
					></div>
				</div>
			) : null}

			{query && !cseId && googleFallback ? (
				<p className="search-fallback">
					<a href={googleFallback} rel="nofollow noopener">
						Ver resultados de “{query}” no Google
					</a>
				</p>
			) : null}
		</section>
	);
}
